import { createAction, createReducer } from "@reduxjs/toolkit";
import { get } from "lodash-es";

const Actions = {
  fetchFundDetails: "fetchFundDetails",
  setFundDetails: "setFundDetails",
  setInvestmentType: "investmentType",
  setInvestmentPeriod: "setInvestmentPeriod",
  setInvestedAmount: "setInvestedAmount",
  setExpectedAmount: "setExpectedAmount",
  setExpectedReturnPerc: "setExpectedReturnPerc",
  setFundTimePeriod: "setFundTimePeriod",
  fetchFundGraphData: "fetchFundGraphData",
  setFundGraphData: "setFundGraphData",
  setAmount: "setAmount",
  resetReturnCalculatorData: "resetReturnCalculatorData",
  resetFundDetails: "resetFundDetails",
  setFundDetailEvent: "setFundDetailEvent",
  setIsReturnCalcOpen: "setIsReturnCalcOpen",
  setIsRetunCompOpen: "setIsRetunCompOpen",
  setIsReturn: "setIsReturn",
  setIsRiskOpen: "setIsRiskOpen",
  setIsAssetOpen: "setIsAssetOpen",
};

// Actions
export const fetchFundDetails = createAction(Actions.fetchFundDetails);
export const setFundDetails = createAction(Actions.setFundDetails);
export const setInvestmentType = createAction(Actions.setInvestmentType);
export const setInvestmentPeriod = createAction(Actions.setInvestmentPeriod);
export const setInvestedAmount = createAction(Actions.setInvestedAmount);
export const setExpectedAmount = createAction(Actions.setExpectedAmount);
export const setExpectedReturnPerc = createAction(
  Actions.setExpectedReturnPerc
);
export const setFundTimePeriod = createAction(Actions.setFundTimePeriod);
export const setAmount = createAction(Actions.setAmount);
export const fetchFundGraphData = createAction(Actions.fetchFundGraphData);
export const setFundGraphData = createAction(Actions.setFundGraphData);
export const resetReturnCalculatorData = createAction(
  Actions.resetReturnCalculatorData
);
export const resetFundDetails = createAction(Actions.resetFundDetails);
export const setFundDetailEvent = createAction(Actions.setFundDetailEvent);

export const setIsReturnCalcOpen = createAction(Actions.setIsReturnCalcOpen);
export const setIsRetunCompOpen = createAction(Actions.setIsRetunCompOpen);
export const setIsReturn = createAction(Actions.setIsReturn);
export const setIsRiskOpen = createAction(Actions.setIsRiskOpen);
export const setIsAssetOpen = createAction(Actions.setIsAssetOpen);

export const getFundData = (state) => {
  return get(state, "fundDetails.fundData", {});
};

const defaultSipAmount = 1000;
const defaultLumpsumAmount = 10000;
const defaultInvestmentType = "sip";

const initialState = {
  fundData: {},
  investmentType: defaultInvestmentType,
  sip: defaultSipAmount,
  lumpsum: defaultLumpsumAmount,
  investmentPeriod: 5,
  investedAmount: 0,
  expectedAmount: 0,
  expectedReturnPerc: 0,
  fundTimePeriod: "3Y",
  fundGraphData: [],
};

export const getRollingReturnData = (state) => {
  const rollingReturnData = get(
    state,
    "fundDetails.fundGraphData.rolling_returns[0]",
    {}
  );
  return rollingReturnData;
};

export default createReducer(initialState, (builder) => {
  builder.addCase(setFundDetails, (state, action) => {
    state.fundData = action.payload;
  });
  builder.addCase(setInvestmentType, (state, action) => {
    state.investmentType = action.payload;
  });
  builder.addCase(setInvestmentPeriod, (state, action) => {
    state.investmentPeriod = action.payload;
  });
  builder.addCase(setInvestedAmount, (state, action) => {
    state.investedAmount = action.payload;
  });
  builder.addCase(setExpectedAmount, (state, action) => {
    state.expectedAmount = action.payload;
  });
  builder.addCase(setExpectedReturnPerc, (state, action) => {
    state.expectedReturnPerc = action.payload;
  });
  builder.addCase(setAmount, (state, action) => {
    state[state.investmentType] = action.payload;
  });
  builder.addCase(setFundTimePeriod, (state, action) => {
    state.fundTimePeriod = action.payload;
  });
  builder.addCase(setFundGraphData, (state, action) => {
    state.fundGraphData = action.payload;
  });
  builder.addCase(resetReturnCalculatorData, (state, action) => {
    state.investmentType = defaultInvestmentType;
    state.sip = defaultSipAmount;
    state.lumpsum = defaultLumpsumAmount;
    state.investmentPeriod = 5;
    state.investedAmount = 0;
    state.expectedAmount = 0;
    state.expectedReturnPerc = 0;
    state.fundTimePeriod = "3Y";
  });
  builder.addCase(resetFundDetails, (state) => {
    return initialState;
  });
  builder.addCase(setFundDetailEvent, (state, action) => {
    state.fundDetailEvent = {
      ...state.fundDetailEvent,
      ...action.payload,
    };
  });
  builder.addCase(setIsReturnCalcOpen, (state, action) => {
    state.isReturnCalcOpen = action.payload;
  });
  builder.addCase(setIsRetunCompOpen, (state, action) => {
    state.isRetunCompOpen = action.payload;
  });
  builder.addCase(setIsReturn, (state, action) => {
    state.isReturn = action.payload;
  });
  builder.addCase(setIsRiskOpen, (state, action) => {
    state.isRiskOpen = action.payload;
  });
  builder.addCase(setIsAssetOpen, (state, action) => {
    state.isAssetOpen = action.payload;
  });
});
